// Array of postcode ranges for Solar Water Heaters
export const solarWaterHeaterZones = [
  { from: 800, to: 854, zone: 1 },
  { from: 860, to: 860, zone: 2 },
  { from: 862, to: 862, zone: 1 },
  { from: 870, to: 875, zone: 2 },
  { from: 880, to: 886, zone: 1 },
  { from: 2000, to: 2914, zone: 3 },
  { from: 3000, to: 3381, zone: 4 },
  { from: 3384, to: 3384, zone: 3 },
  { from: 3385, to: 3387, zone: 4 },
  { from: 3388, to: 3396, zone: 3 },
  { from: 3400, to: 3413, zone: 4 },
  { from: 3414, to: 3424, zone: 3 },
  { from: 3427, to: 3451, zone: 4 },
  { from: 3453, to: 3465, zone: 3 },
  { from: 3467, to: 3469, zone: 4 },
  { from: 3472, to: 3520, zone: 3 },
  { from: 3521, to: 3522, zone: 4 },
  { from: 3523, to: 3649, zone: 3 },
  { from: 3658, to: 3658, zone: 4 },
  { from: 3659, to: 3709, zone: 3 },
  { from: 3711, to: 3723, zone: 4 },
  { from: 3725, to: 3749, zone: 3 },
  { from: 3750, to: 3898, zone: 4 },
  { from: 3900, to: 3900, zone: 3 },
  { from: 3902, to: 3996, zone: 4 },
  { from: 4000, to: 4419, zone: 3 },
  { from: 4420, to: 4420, zone: 1 },
  { from: 4421, to: 4428, zone: 3 },
  { from: 4454, to: 4454, zone: 1 },
  { from: 4455, to: 4465, zone: 3 },
  { from: 4467, to: 4468, zone: 1 },
  { from: 4470, to: 4474, zone: 2 },
  { from: 4477, to: 4477, zone: 1 },
  { from: 4478, to: 4482, zone: 2 },
  { from: 4486, to: 4488, zone: 3 },
  { from: 4489, to: 4493, zone: 2 },
  { from: 4494, to: 4615, zone: 3 },
  { from: 4620, to: 4724, zone: 1 },
  { from: 4725, to: 4725, zone: 2 },
  { from: 4726, to: 4726, zone: 1 },
  { from: 4727, to: 4731, zone: 2 },
  { from: 4732, to: 4735, zone: 1 },
  { from: 4736, to: 4736, zone: 2 },
  { from: 4737, to: 4824, zone: 1 },
  { from: 4825, to: 4830, zone: 2 },
  { from: 4849, to: 4895, zone: 1 },
  { from: 5000, to: 5214, zone: 3 },
  { from: 5220, to: 5223, zone: 4 },
  { from: 5231, to: 5261, zone: 3 },
  { from: 5262, to: 5263, zone: 4 },
  { from: 5264, to: 5270, zone: 3 },
  { from: 5271, to: 5291, zone: 4 },
  { from: 5301, to: 6256, zone: 3 },
  { from: 6258, to: 6262, zone: 4 },
  { from: 6271, to: 6317, zone: 3 },
  { from: 6318, to: 6338, zone: 4 },
  { from: 6341, to: 6341, zone: 3 },
  { from: 6343, to: 6348, zone: 4 },
  { from: 6350, to: 6353, zone: 3 },
  { from: 6355, to: 6357, zone: 4 },
  { from: 6358, to: 6395, zone: 3 },
  { from: 6396, to: 6398, zone: 4 },
  { from: 6401, to: 6438, zone: 3 },
  { from: 6440, to: 6440, zone: 2 },
  { from: 6442, to: 6443, zone: 3 },
  { from: 6445, to: 6452, zone: 4 },
  { from: 6460, to: 6640, zone: 3 },
  { from: 6642, to: 6725, zone: 2 },
  { from: 6726, to: 6743, zone: 1 },
  { from: 6751, to: 6799, zone: 2 },
  { from: 7000, to: 7470, zone: 4 }
];

// Utility function to get zone by postcode
export function getSolarWaterHeaterZone(postcode: number): number | null {
  const range = solarWaterHeaterZones.find(r => postcode >= r.from && postcode <= r.to);
  return range ? range.zone : null; // null if postcode not in list
}

const stockData: { [key: string]: { [key: number]: { quantity: number; price: number } } } = {
  "H-PASHW015-270LD-R290": {
    1: { quantity: 15, price: 525 },
    2: { quantity: 15, price: 525 },
    3: { quantity: 18, price: 630 },
    4: { quantity: 19, price: 665 },
    5: { quantity: 19, price: 665 }
    // fill in based on B35 row R–AA
  },
  "H-PASHW008-180LD-R290": {
    1: { quantity: 14, price: 490 },
    2: { quantity: 13, price: 455 },
    3: { quantity: 16, price: 560 },
    4: { quantity: 17, price: 595 },
    5: { quantity: 16, price: 560 }
    // fill in based on B36 row R–AA
  }
};


export function getSTCValues(postcode: number, stockCode: string) {
  const zone = getSolarWaterHeaterZone(Number(postcode));
  if (!zone) return { zone: null, quantity: null, price: null };

  const data = stockData[stockCode];
  if (!data || !data[zone]) {
    return { zone, quantity: null, price: null };
  }

  return {
    zone,
    quantity: data[zone].quantity,
    price: data[zone].price
  };
}